<template>
    <ai-grid-edit
        ref='gridRef'
        :meta='gridMeta'
        :args="gridArgs"
        :hasntRoute="true"
        :action="action"
        :to-remove-toolbar-items-names='removeGridToolbarBtns'
        :showFooter="false"
        @editGridMounted="onEditGridMounted"
        @user-data-changed="onUserDataChanged"
        @toolbar-button-click="onToolbarClickGrid"
        class="widget-tep-net"
    ></ai-grid-edit>
</template>
<script>
    export default {
        name: 'widget-tep-net',
    }
// TODO :: Global.Kod_esys) == 30 - add column prim "Наименование участка" (width: 220, index: 4)
// TODO ::  (r.Field<decimal?>("KOD_PR_OT") == 5||r.Field<decimal?>("KOD_PR_OT") == 14 )) r.SetField("HGR",(decimal?)1.2); // для Теплоэнерго
</script>
<script setup>
import { onMounted, ref } from 'vue';
import { getCookie } from '@/utils/cookies';
import tepService from '@/service/tep-service';
import AiGridEdit from '@/components/ai-grid-edit/ai-grid-edit.vue';

const gridRef = ref(null);
const gridInstance = ref();
const gridArgs = ref(null);
const defaultSaveArgs = ref({kod_sx: -1, depId: +getCookie('dep')});
const keyFocus = ref(null);
const dataFieldFocus = ref(null);
const lookupTipUch = ref(null);
const lookupUchTgr = ref(null);
const lookupUuDiam = ref(null);
const lookupUchProkl = ref(null);
const lookupTipIzol = ref(null);
const addClickNew = ref(false);
const yearRow = ref(null);

const props = defineProps({
    userData: {
        type: Object,
        default: () => {
            return {};
        },
    },
    action: {
        type: Function,
        default: null,
    },
    id: {
        type: String,
    }
});

const emit = defineEmits(['close-popup']);

onMounted( async () => {
    await setDataSourceFunc();
});

const setDataSourceFunc = async () => {
    defaultSaveArgs.value.kod_sx = props.userData?.kod;
    const defaultGridArgs = {
        select: {
            select_args: { ...defaultSaveArgs.value },
        },
        save: {
            update_args: { ...defaultSaveArgs.value },
            insert_args: { ...defaultSaveArgs.value },
            delete_args: { ...defaultSaveArgs.value },
        },
    };
    gridArgs.value = { ...defaultGridArgs };
    await gridRef.value?.setDataSource(null, gridArgs.value.select );
    await getLookupsData();
}

const onEditGridMounted = async () => {
    gridInstance.value = gridRef?.value.gridInstance;
    await gridInstance.value.on('cellClick', onCellClick);
};

const getLookupsData = async () => {
    const args = { select_args: { ...defaultSaveArgs.value, kod_sx: -1 } };
    const argsUch = { select_args: { kod_vid: props.userData?.kod_vid } };
    lookupTipUch.value = await tepService.getLookupsDataTepNet('tep-grid./tep/widgets/lookup-tip-uch/get', {});
    lookupUchTgr.value = await tepService.getLookupsDataTepNet('tep-grid./tep/widgets/lookup-uch-tgr/get', args);
    lookupUuDiam.value = await tepService.getLookupsDataTepNet('tep-grid./tep/lookup-uu-diam/select/get', {});
    lookupUchProkl.value = await tepService.getLookupsDataTepNet('tep-grid./tep/widgets/lookup-uch-prokl/get', argsUch);
    lookupTipIzol.value = await tepService.getLookupsDataTepNet('tep-grid./tep/widgets/lookup-tip-izol/get', {});
}

const onCellClick = async event => {
    const arrEdit = ['kod_tip_uch', 'kod_tgr', 'pt_d', 'pt_l', 'kod_pr_pt', 'pt_iztr_t'];
    if(event.column && arrEdit.includes(event.column.dataField)) {
        keyFocus.value = event.key;
        dataFieldFocus.value =event.column.dataField;
        yearRow.value = event?.row?.data?.year;
        gridRef.value?.gridInstance.columnOption(event.column.dataField, {componentMeta: getDropdownComponent(event?.row?.data?.year)});
    } else {
        keyFocus.value = null;
        dataFieldFocus.value = null;
    }
};

const onToolbarClickGrid = async (event) => {
    const  nameBtnclick = event?.item?.component?.name;
    if(nameBtnclick === 'add') addClickNew.value = true;
};

const getDropdownComponent = (year = null) => {
    return {
        path: 'components/ai-grid-ro/ai-grid-ro.vue',
        text: 'name',
        minHeight: '200px',
        meta: {
            keyExpr: 'kod',
            columns: [
                {dataField: 'kod', caption: 'kod', visible: false},
                {dataField: 'name', caption: ''}
            ],
            api: { select: 'tep-grid./tep/widgets/lookup-uch-prokl/get'},
        },
        args: { select_args: { kod_vid: props.userData?.kod_vid, year: year } }
    }
};

const onUserDataChanged = async (userData) => {
    // Добавление новой строки и присвоения значений по умолчанию
    if(addClickNew.value) {
        await getNewDataRow(userData);
    }
    // Зависимости полей
    if(keyFocus.value && dataFieldFocus.value) {
        const dataKeyChanges = userData.changes?.gridChanges.filter(i => i.key === keyFocus.value);
        if(dataKeyChanges.length) {
            dataKeyChanges.map( async item => {
                if(dataFieldFocus.value === 'kod_tip_uch') {
                    const args = { ...defaultSaveArgs.value, kod_tip_uch: item.data['kod_tip_uch'] };
                    const dataUpdateRow = await tepService.getQrUchNewRow(args);
                    item.data['kod_tgr'] = dataUpdateRow[0].kod_tgr;
                    item.data['t1'] = dataUpdateRow[0].t1_so;
                    item.data['t2'] = dataUpdateRow[0].t2_so;
                }
                if(dataFieldFocus.value === 'kod_tgr') {
                    const dataTemp = lookupUchTgr.value?.find(i => i.kod === item.data['kod_tgr']);
                    item.data['t1'] = dataTemp.t1;
                    item.data['t2'] = dataTemp.t2;
                }
                if(dataFieldFocus.value === 'pt_d') {
                    item.data['ot_d'] = item.data['pt_d'];
                }
                if(dataFieldFocus.value === 'pt_l') {
                    item.data['ot_l'] = item.data['pt_l'];
                }
                if(dataFieldFocus.value === 'kod_pr_pt') {
                    item.data['kod_pr_ot'] = item.data['kod_pr_pt'];
                    item.data['name_pr_ot'] = item.data['name_pr_pt'];
                }
                if(dataFieldFocus.value === 'pt_iztr_t') {
                    item.data['ot_iztr_t'] = item.data['pt_iztr_t'];
                    item.data['name_ot_iztr_t'] = item.data['name_pt_iztr_t'];
                }
            })
        }
    }
}

const getNewDataRow = async (userData) => {
    let insertEventData = userData.changes?.gridChanges?.filter(el => el.type === 'insert') ?? [];
    insertEventData = insertEventData.filter(el => el.data.kod_tip_uch === null);
    if(insertEventData.length !== 0) {
        let findNomUchInsert = userData.changes?.gridChanges?.map(item => item.data.nom_uch);
        findNomUchInsert = findNomUchInsert.filter(element => element !== null);
        const dataGrid = await gridRef.value?.getGridDataSource() ?? [];
        const findNomUchGrid = dataGrid.map(item => item.nom_uch);
        let allNomUch = [...findNomUchInsert, ...findNomUchGrid];
        allNomUch = allNomUch.filter(item => typeof item === 'number' || typeof item === 'string');
        let nomUch = 0;
        if(allNomUch.length) {
            nomUch = Math.max(...allNomUch);
        }
        const args = { ...defaultSaveArgs.value, kod_tip_uch: 1 };
        const dataNewRow = await tepService.getQrUchNewRow(args);
        insertEventData.map(item => {
            item.data['kod_sx'] = props.userData?.kod;
            item.data['kod_tip_uch'] = 1;
            item.data['kod_tgr'] = dataNewRow[0].kod_tgr;
            item.data['year'] = 1958;
            item.data['kodp'] = props.userData?.kod_abon;
            item.data['nom_uch'] = +nomUch + 1;
            item.data['t1'] = dataNewRow[0].t1_so;
            item.data['t2'] = dataNewRow[0].t2_so;
        })
        gridInstance.value.refresh();
        addClickNew.value = false;
    }
};

const beforeInstanceClose = async () => {
    const canClose = await gridRef.value?.checkBeforeClose();
    if (!canClose) return false;
    emit('close-popup', 'widget-tep-net');
}

defineExpose({
    beforeInstanceClose: beforeInstanceClose,
    id: props.id,
});


const removeGridToolbarBtns = [ 'edit', 'choice', 'show-column-chooser', 'searchPanel', 'copy', 'export'];

const gridMeta =  {
    'keyExpr': 'kod_uch',
    'isFilterPanelVisible': false,
    'columns': [
        {
            'name': 'kod_uch',
            'caption': 'kod_uch',
            'dataField': 'kod_uch',
            'allowEditing': false,
            'width': 250,
            'index': 1,
            'visible': false,
        },
        {
            'name': 'kod_sx',
            'caption': 'kod_sx',
            'dataField': 'kod_sx',
            'allowEditing': false,
            'width': 250,
            'index': 2,
            'visible': false,
        },
        {
            'name': 'kod_tip_uch',
            'caption': 'Тип участка',
            'dataField': 'kod_tip_uch',
            'allowEditing': true,
            'width': 150,
            'index': 4,
            'visible': true,
            'fixed': true,
            "editor": {
                "type": "ai-drop-down",
                "text": "name_tip_uch",
            },
            "component": {
                "name": "lookup-tip-uch",
                "id": "kod",
                "text": "name",
                'minHeight': '200px'
            },
            calculateDisplayValue: (rowData) => {
                const kod = rowData.kod_tip_uch;
                const name = rowData.name_tip_uch;
                const match = lookupTipUch.value?.find(i => i.kod === kod);
                return match ? match.name : name;
            }
        },
        {
            'name': 'kod_tgr',
            'caption': 'Темп.гр.',
            'dataField': 'kod_tgr',
            'allowEditing': true,
            'width': 150,
            'index': 5,
            'visible': true,
            'fixed': true,
            "editor": {
                "type": "ai-drop-down",
                "text": "name_tgr",
            },
            "component": {
                "name": "lookup-uch-tgr",
                "id": "kod",
                "text": "name",
                'minHeight': '200px',
                args: {
                    select_args: { ...defaultSaveArgs.value, kod_sx: -1 },
                }
            },
            calculateDisplayValue: (rowData) => {
                const kod = rowData.kod_tgr;
                const name = rowData.name_tgr;
                const match = lookupUchTgr.value?.find(i => i.kod === kod);
                return match ? match.name : name;
            }
        },
        {
            'name': 'year',
            'caption': 'Год',
            'dataField': 'year',
            'allowEditing': true,
            'width': 130,
            'index': 6,
            'visible': true,
            "editor": {
                "type": "ai-drop-down",
                "text": "year",
            },
            "component": {
                "name": "lookup-uch-years",
                "id": "year",
                "text": "year",
                'minHeight': '200px'
            },
        },
        {
            'name': 'nom_uch',
            'caption': '№',
            'dataField': 'nom_uch',
            'allowEditing': true,
            'width': 130,
            'index': 7,
            'visible': true,
            'dataType': 'number',
            "editor": {
                "type": "number",
            },
            format: { type: "decimal", precision: 0 },
            editorOptions: {
                min: 0,
                max: 9999999999,
                onKeyPress(e) {
                    if (e.event.key === '.' || e.event.key === ',') {
                        e.event.preventDefault();
                    }
                },
                onInput(e) {
                    const val = e.event.target.value;
                    if (val.length > 10) {
                        e.event.target.value = val.slice(0, 10); // обрезаем ввод
                    }
                }
            }
        },
        {
            'name': 'pt_d',
            'caption': 'Диаметр под. тр-д',
            'dataField': 'pt_d',
            'allowEditing': true,
            'width': 130,
            'index': 8,
            'visible': true,
            "editor": {
                "type": "ai-drop-down",
                "text": "pt_d",
            },
            "component": {
                "name": "lookup_uu_diam",
                "id": "kod",
                "text": "kod",
                'minHeight': '200px'
            }
        },
        {
            'name': 'pt_l',
            'caption': 'Длина под. тр-д',
            'dataField': 'pt_l',
            'allowEditing': true,
            'width': 130,
            'index': 9,
            'visible': true,
            'dataType': 'number'
        },
        {
            'name': 'kod_pr_pt',
            'caption': 'Тип прокладки под тр-д',
            'dataField': 'kod_pr_pt',
            'allowEditing': true,
            'width': 130,
            'index': 10,
            'visible': true,
            "editor": {
                "type": "ai-drop-down",
                "text": "name_pr_pt",
            },
            component: getDropdownComponent(yearRow.value),
        },
        {
            'name': 'pt_iztr_t',
            'caption': 'Тип изоляции под тр-д',
            'dataField': 'pt_iztr_t',
            'allowEditing': true,
            'width': 130,
            'index': 11,
            'visible': true,
            "editor": {
                "type": "ai-drop-down",
                "text": "name_pt_iztr_t"
            },
            "component": {
                "name": "lookup-tip-izol",
                "id": "kod",
                "text": "name",
                'minHeight': '200px'
            }
        },
        {
            'name': 'ot_d',
            'caption': 'Диаметр обр. тр-д',
            'dataField': 'ot_d',
            'allowEditing': true,
            'width': 130,
            'index': 12,
            'visible': true,
            "editor": {
                "type": "ai-drop-down",
                "text": "ot_d"
            },
            "component": {
                "name": "lookup_uu_diam",
                "id": "kod",
                "text": "kod",
                'minHeight': '200px'
            },
            calculateDisplayValue: (rowData) => {
                const kod = rowData.ot_d;
                const match = lookupUuDiam.value?.find(i => i.kod === kod);
                return match ? match.kod : kod;
            }
        },
        {
            'name': 'ot_l',
            'caption': 'Длина обр. тр-д',
            'dataField': 'ot_l',
            'allowEditing': true,
            'width': 130,
            'index': 13,
            'visible': true,
            'dataType': 'number'
        },
        {
            'name': 'kod_pr_ot',
            'caption': 'Тип прокладки обр. тр-д',
            'dataField': 'kod_pr_ot',
            'allowEditing': true,
            'width': 130,
            'index': 14,
            'visible': true,
            "editor": {
                "type": "ai-drop-down",
                "text": "name_pr_ot"
            },
            component: getDropdownComponent(yearRow.value),
            calculateDisplayValue: (rowData) => {
                const kod = rowData.kod_pr_ot;
                const name = rowData.name_pr_ot;
                const match = lookupUchProkl.value?.find(i => i.kod === kod);
                return match ? match.name : name;
            }
        },
        {
            'name': 'ot_iztr_t',
            'caption': 'Тип изоляции обр. тр-д',
            'dataField': 'ot_iztr_t',
            'allowEditing': true,
            'width': 130,
            'index': 15,
            'visible': true,
            "editor": {
                "type": "ai-drop-down",
                "text": "name_ot_iztr_t"
            },
            "component": {
                "name": "lookup-tip-izol",
                "id": "kod",
                "text": "name",
                'minHeight': '200px'
            },
            calculateDisplayValue: (rowData) => {
                const kod = rowData.ot_iztr_t;
                const name = rowData.name_ot_iztr_t;
                const match = lookupTipIzol.value?.find(i => i.kod === kod);
                return match ? match.name : name;
            }
        },
        {
            'name': 'hgr',
            'caption': 'Глубина залегания',
            'dataField': 'hgr',
            'allowEditing': true,
            'width': 130,
            'index': 16,
            'visible': true,
            "editor": {
                "type": "ai-drop-down",
                "text": "hgr"
            },
            "component": {
                "name": "lookup-uch-hgr",
                "id": "hgr",
                "text": "hgr",
                'minHeight': '200px'
            }
        },
        {
            'name': 'kodp',
            'caption': 'Балансовая принадлежность',
            'dataField': 'kodp',
            'allowEditing': true,
            'width': 250,
            'index': 18,
            'visible': true,
            editor: { type: 'ai-popup', text: 'bal_name' },
            component: {
                id: 'kodp',
                text: 'name',
                path: 'components/dictionary-components/ai-dictionary-virtual-grid.vue',
                saveButtonVisible: false,
                title: 'Выбор балансовой принадлежности',
                width: '1100px',
                meta: {
                    keyExpr: 'kodp',
                    columns: [
                        {field: 'kodp', text: 'kodp', data_type: 'number', visible: false},
                        {field: 'nump', text: '№ абонента', data_type: 'number', visible: true, width: 100},
                        {field: 'name', text: 'Абонент', visible: true, width: 350},
                        {field: 'allname', text: 'Полное название абонента', visible: true, width: 350},
                        {field: 'inn', text: 'ИНН', visible: true, width: 100},
                        {field: 'ndogs', text: 'Договоры', visible: true, width: 100},
                    ],
                    loadUrl: 'tep-grid./tep/search/payer/data/get',
                    autoLoadData: false,
                    FilterPanelShow: false,
                    toRemoveToolbarItemsNames: ['copy', 'edit', 'add', 'delete', 'save', 'group-area', 'show-column-chooser', 'export']
                },
            },
        },
        {
            'name': 'pq_oxl',
            'caption': 'Потери тепла с охлаждением [Ккал/час]',
            'dataField': 'pq_oxl',
            'allowEditing': false,
            'width': 130,
            'index': 19,
            'visible': true,
            'dataType': 'number'
        },
        {
            'name': 'pq_ut',
            'caption': 'Потери тепла с утечкой [Ккал/час]',
            'dataField': 'pq_ut',
            'allowEditing': false,
            'width': 130,
            'index': 20,
            'visible': true,
            'dataType': 'number'
        },
        {
            'name': 'pg_ut',
            'caption': 'Потери воды с утечкой [т/час]',
            'dataField': 'pg_ut',
            'allowEditing': false,
            'width': 130,
            'index': 21,
            'visible': true,
            'dataType': 'number'
        },
        {
            'name': 't1',
            'caption': 'Код ттемп.гр.',
            'dataField': 't1',
            'allowEditing': true,
            'width': 130,
            'index': 22,
            'visible': true,
            'dataType': 'number'
        },
        {
            'name': 't2',
            'caption': 'Код ттемп.гр.',
            'dataField': 't2',
            'allowEditing': true,
            'width': 130,
            'index': 23,
            'visible': true,
            'dataType': 'number'
        },

    ],
    'api': {
        'select': 'tep-grid./tep/widgets/qr-uch/select/get',
        'save': 'tep-grid./tep/widgets/qr-uch/save/set',
    },
    'viewId': 'widget-tep-net',
};
</script>
<style scoped>

</style>
